import { Link } from "react-router-dom";
import { useProduct } from "../../context/ProductContext";
import { useEffect, useState } from "react";

function SuggestionCard() {
  const { pizzas, drinks, desserts, extras } = useProduct();
  const [combo, setCombo] = useState();

  useEffect(() => {
    setCombo(randomProducts());
  }, []);

 
  //método para obtener productos aleatorios
  const randomProducts = () => {
    //array con los productos aleatorios
    let productCombo = [];

    // variables para guardar el indice aleatorio del array de productos
    let indexPizza,
      indexDrink,
      indexDessert,
      indexExtra = 0;

    //obtenemos el indice aleatorio de cada categoria
    indexPizza = Math.floor(Math.random() * (pizzas.length - 1 + 1)+1)-1;
    indexDrink = Math.floor(Math.random() * (drinks.length - 1 + 1)+1)-1;
    indexDessert = Math.floor(Math.random() * (desserts.length - 1 + 1)+1)-1;
    indexExtra = Math.floor(Math.random() * (extras.length - 1 + 1)+1)-1;

    productCombo[0] = { product: drinks[indexDrink], category: "drink" };
    productCombo[1] = { product: desserts[indexDessert], category: "dessert" };
    productCombo[2] = { product: extras[indexExtra], category: "extra" };

    console.log(indexPizza);

    return productCombo;
  };

  console.log(combo);


  // 1. Caso especial: Placeholder para "Ver más opciones del menú"
  if (!combo) {
    return (
      <div style={{ width: "473px" }}>
        <Link
          to="/menu"
          className="suggestion-card placeholder-card"
          style={{
            textDecoration: "none",
            color: "black",
            display: "block",
          }}
        >
          <div
            className="placeholder-icon text-center"
            style={{
              height: "275px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              border: "2px dashed #ccc",
              borderRadius: "8px",
              backgroundColor: "#f8f9fa",
            }}
          >
            <span className="plus-sign fs-1" style={{ color: "#6c757d" }}>
              +
            </span>
          </div>
          <p
            className="placeholder-text mt-3 text-center"
            style={{ fontSize: "1.5rem", color: "#6c757d" }}
          >
            Ver más opciones del menú
          </p>
        </Link>
      </div>
    );
  }

  return (
    <>
      {combo.map((item) => (
        <div style={{ width: "473px" }}>
          <Link
            to={`/producto/${item.category}/${item.product.id}`}
            className="suggestion-card"
            style={{
              textDecoration: "none",
              color: "black",
              display: "block",
            }}
          >
            <div className="suggestion-card-image">
              <img
                src={item.product.image_link}
                alt={item.product.name}
                width="473"
                height="275"
                className="rounded"
                style={{
                  objectFit: "cover",
                  display: "block",
                  width: "100%",
                  height: "275px",
                }}
                onError={(e) => {
                  e.target.src =
                    "https://via.placeholder.com/473x275?text=Imagen+no+disponible";
                }}
              />
            </div>
            <div
              className="suggestion-card-content"
              style={{ padding: "15px 0" }}
            >
              <h4
                className="suggestion-card-title"
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  fontSize: "1.25rem",
                  fontWeight: "bold",
                }}
              >
                {item.product.name}
              </h4>
              <p
                className="suggestion-card-description"
                style={{
                  width: "100%",
                  color: "#6c757d",
                  marginBottom: "10px",
                  lineHeight: "1.4",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {item.product.description}
              </p>
            </div>
          </Link>
        </div>
      ))}
    </>
  );
}

export default SuggestionCard;
